<template>
  <div class="mainContainer blaLoginContainer">
    <!-- ERROR SNIPPET -->
    <v-snackbar
      v-model="error.show"
      color="error"
      top
      :timeout="error.timeout"
      text-xs-center
    >
      {{ error.message }}
      <v-icon right dark>error_outline</v-icon>
    </v-snackbar>

    <div class="row">
      <div class="col-10 offset-1 blaLoginLogoBox">
        <img
          :src="require('@/assets/img/skillers_logo_2x.png')"
          class="img-fluid w-75"
          alt="Skillers logo"
          @click="$router.push({ name: 'WebApp' })"
        />
      </div>
      <div class="col-10 offset-1 col-lg-4 offset-lg-4 mt-2">
        <div class="blaLoginBox">
          <div class="blaLoginBoxTitle text-center mt-3">
            Új jelszó kérése
          </div>
          <div class="row pt-3">
            <div class="col-10 offset-1 alert alert-warning">
              <div class="row align-center">
                <div class="col-2 text-right">
                  <i class="fas fa-2x fa-exclamation-triangle"></i>
                </div>
                <div class="col-10 text-justify">
                  A rendszer egy e-mailben elküldött egy PIN kódot, amivel
                  biztonságosan megváltoztathatod a jelszavad!
                </div>
              </div>
            </div>
            <div class="col-10 offset-1">
              <div class="form-group mb-3">
                <label for="pin">PIN kód</label>
                <input
                  v-model="form.pin"
                  type="text"
                  class="form-control blaInput"
                  placeholder=""
                  id="pin"
                />
              </div>
              <div class="form-group mb-3">
                <label for="password">Új jelszó</label>
                <input
                  v-model="form.password"
                  type="password"
                  class="form-control blaInput"
                  placeholder=""
                  id="password"
                />
              </div>
            </div>
            <div class="col-10 offset-1 text-center align-content-center mt-4">
              <div class="blaLoginButton2" @click="getNewPasswordWithPIN">
                Módosítás
              </div>
            </div>
            <div class="col-10 offset-1 text-center align-content-center mt-4">
              <div class="blaLoginButton2" @click="goToLogin">
                Vissza
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    form: {
      pin: '',
      password: '',
      passwordShow: false,
      show: true
    },
    error: {
      show: false,
      code: '',
      message: ''
    },
    rules: {
      required: value => !!value || 'Kötelező'
    },
    notification: {
      show: true
    }
  }),
  methods: {
    getNewPasswordWithPIN() {
      axios
        .post(this.$store.getters.getApiUrl + '/api/password/reset/pin', {
          pin: this.$data.form.pin,
          password: this.$data.form.password
        })
        .then(response => {
          this.$data.form.show = false;
          this.$data.notification.show = true;
          this.$data.error.show = false;
          this.$router.push({ name: 'MobileMain' });
        })
        .catch(error => {
          this.$data.error.message = error.response.data.message;
          this.$data.error.code = error.response.data.code;
          this.$data.error.show = true;
        });
    },
    goToLogin() {
      //Move to stepfield
      this.$router.push({ name: 'MobileMain' });
    }
  },
  mounted() {}
};
</script>
